module.exports = __webpack_public_path__ + "static/media/icon-account-bright-red.57bcd765.svg";